<template>
<div class="large-container">
	<div class="title">{{info.productName}}</div>
	<Form :label-width="120" class="mt15">
		<FormItem label="保单号：" class="mb5">
			{{info.policyNo}}
			<a :href="info.policyUrl" v-if="info.policyUrl" target="_blank" class="ml10">查看保单</a>
		</FormItem>
		<FormItem label="保障状态：" class="mb5">
			{{info.insuranceStatusName}}
		</FormItem>
		<FormItem label="保费：" class="mb5">
			{{info.premium}} 元
		</FormItem>
	</Form>
	<div class="title">参加人员信息</div>
	<p class="totalM mt10">共{{list.length}}人</p>
	<Table :columns="columns" :data="list" border ></Table>
</div>
</template>
<script>
export default {
	data () {
		return {
			info:{},
			id:this.$route.params.id,
			list:[],
			columns:[
				{title: '序号',type: 'index',width:90},
				{title: '投保日期',key: 'createTime',width:180},
				{title: '姓名',key: 'insurantName',width:120},
				{title: '性别',key: 'insurantGenderName',width:65},
				{title: '证件类型',key: 'insurantIdTypeName',width:95},
				{title: '证件号码',key: 'insurantIdNumber',width:190},
				{title: '出生日期',key: 'insurantBirthday',width:120},
				{title: '参保公司',key: 'companyName',minWidth:200},
				{title: '起保日期',key: 'effectiveDateStart',width:180},
				{title: '终保日期',key: 'effectiveDateEnd',width:180},
				{title: '保费（元）',key: 'premiumAmount',width:110},
			],
		}
	},
	created () {
		this.getInfo();
	},
	methods:{
		/*获取订单信息*/
		getInfo () {
			this.$axios.post('/trainee/queryPolicyDetail',{
				policyId:this.id
			}).then(res=>{
				this.info=res
			});
			this.$axios.post('/trainee/queryPolicyUser',{
				policyId:this.id,
				page:1,
				count:9999
			}).then(res=>{
				this.list=res
			});
		},
	}
}
</script>
<style scoped lang="less">
.mb5{
	margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/detail/Policy.vue